<template>
	<div class="container">
		<header :class="[increaseHeader ? 'extended' : 'shorten']"></header>
		<div class="content">
			<label for="menu-open-chk" class="menu-open">
				<span class="fas fa-bars"></span>
			</label>

			<input type="checkbox" id="menu-open-chk" class="menu-open-chk" />

			<aside>
				<h1>
					<router-link :to="{ name: 'home' }">
						<img src="@/assets/img/ensineme.png" alt="Projeto Joana" class="logo" />
					</router-link>
				</h1>

				<!-- <div :class="[!increaseHeader && 'hide', 'user']">
					<div class="photo" :style="styleObjectUserPhoto"></div>
					<strong class="name">{{ this.$auth.user().nome }}</strong>
					<span class="email"> {{ this.$auth.user().email }}</span>
					<em class="profile">{{ getUserProfile()  }}</em>
				</div> -->

				<div class="nav-container">

					<!-- <h2>Minha área exclusiva</h2> -->

					<!-- <div :class="[!increaseHeader && '', 'user']">
						<div class="photo" :style="styleObjectUserPhoto"></div>
						<strong class="name">{{ this.$auth.user().nome }}</strong>
						<span class="email"> {{ this.$auth.user().email }}</span>
						<em class="profile">{{ getUserProfile() }}</em>
					</div> -->

					<nav :class="[increaseHeader ? 'extended' : 'shorten']">
						<box-menu-main icon="fas fa-home" title="Home" routeName="home" :exact="true" />
						<box-menu-main v-if="this.$auth.user().perfil === 1 || this.$auth.user().perfil === 2" icon="fas fa-users" title="Usuários" routeName="usuariosList" />
						<box-menu-main icon="fas fa-cubes" title="Objetos" routeName="objetoList" />
						<box-menu-main icon="fa fa-database" title="Curadores e Produção" routeName="listData" />
						<box-menu-main icon="fa fa-sitemap" title="Árvore de Objeto" routeName="arvoreObjeto" />
						<box-menu-main v-if="this.$auth.user().perfil === 1" icon="fas fa-list-alt" title="Tipos de Objeto" routeName="tiposList" />
						<box-menu-main v-if="this.$auth.user().perfil !== 6" icon="fas fa-graduation-cap" title="Curadorias" routeName="curadoriaList" />
						<!-- <box-menu-main v-if="this.$auth.user().perfil !== 6" icon="fas fa-traffic-light" title="Status" routeName="status" /> -->
						<box-menu-main v-if="this.$auth.user().perfil === 1" icon="fab fa-elementor" title="Nível dificuldade" routeName="nivelDificuldadeList" />
						<box-menu-main v-if="this.$auth.user().perfil === 1" icon="fas fa-envelope-open-text" title="Tipos de Questões" routeName="tiposQuestoesList" />
						<box-menu-main :materialIcon="true" :squaredMaterial="true" icon="spellcheck" title="Questões" routeName="questoesList" />
						<box-menu-main v-if="this.$auth.user().perfil !== 6" icon="fas fa-briefcase" title="Clientes" routeName="clienteList" />
						<!-- <box-menu-main v-if="this.$auth.user().perfil !== 6" icon="fas fa-folder" title="Coleções" routeName="colecoesList" /> -->
					</nav>
				</div>
			</aside>

			<section class="main-content">

				<nav>
					<div class="search">
						<!--	<i class="fas fa-search"></i>
						<input type="search" placeholder="Busque por autor, tema, objeto e muito mais." autocomplete="off" />-->
					</div>

					<div class="logged-user">
						<router-link class="routerLink" :to="{ path: `/usuarios/${this.$auth.user().id}` }">
							<div class="user">
								<!-- <div class="thumb" :style="styleObjectUserPhoto"></div>
								<span>{{ getUserProfile()  }}</span> -->
								<span>{{ this.$auth.user().nome }}</span>
							</div>
						</router-link>

						<button type="button" @click="logout">
							<i class="fas fa-sign-out-alt"></i>
							<span>Sair</span>
						</button>
					</div>
				</nav>
				<websocket-notification></websocket-notification>
				<div class="main">
					<main>
						<transition name="fade" mode="out-in" appear>
							<router-view />
						</transition>
					</main>
				</div>
			</section>
		</div>
		<footer>
			<div class="credits max-width">
				<div class="help-box">
					<i class="fas fa-question-circle"></i>
					<span class="help-text">PRECISA DE AJUDA ?</span>
					<span class="email">ed.tech@estacio.br</span>
				</div>

				<p>Este software tem por finalidade viabilizar a consulta e o consumo de recursos educacionais, mediante serviço prévio de curadoria de conteúdo. Trata-se de um desenvolvimento integrante do projeto 2020, da Diretoria Acadêmica do grupo Estácio.</p>
				<img src="@/assets/img/ensineme.png" alt="Projeto Joana" class="logo-rodape" />
			</div>

			<!-- <div class="social-networks">
				<div class="end max-width">
					<div class="copy"><p>Estácio de Sá - Todos os direitos reservados</p></div>
					<div class="socials">
						<a href="" target="_blank">
							<i class="fab fa-facebook-f"></i>
						</a>
						<a href="" target="_blank">
							<i class="fab fa-twitter"></i>
						</a>
						<a href="" target="_blank">
							<i class="fab fa-instagram"></i>
						</a>
						<a href="" target="_blank">
							<i class="fab fa-youtube"></i>
						</a>
						<a href="" target="_blank">
							<i class="fab fa-linkedin-in"></i>
						</a>
					</div>
				</div>
			</div> -->
		</footer>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getUserProfile } from '@/helpers/GetUserProfile'
import BoxMenuMain from '@/components/layouts/inc/BoxMenuMain'
import DefaultUserImage from '@/assets/img/noimage.svg'
import WebsocketNotification from '@/components/shared/WebsocketNotification'

export default {
	name: 'MainLayout',
	data () {
		return {
			increaseHeader: false,
			styleObjectUserPhoto: {
				background: this.$auth.user().imagemAvatar ? 'url(' + this.$auth.user().imagemAvatar + ')' : 'url(' + DefaultUserImage + ')',
				backgroundSize: 'cover',
				backgroundPositionY: '15px',
				backgroundRepeat: 'no-repeat'
			},
			perfil: ''
		}
	},
	components: {
		BoxMenuMain, WebsocketNotification
	},
	async created () {
		if (this.$route.path === '/') this.increaseHeader = true
		this.getProfiles()
		this.loadAllTypesQuestions()
	},
	updated () {
		if (this.$route.path !== '/') this.increaseHeader = false
		else this.increaseHeader = true
	},
	methods: {
		...mapActions(['getProfiles', 'loadAllTypesQuestions']),
		logout () {
			this.$auth.logout({ makeRequest: false, redirect: '/login' })
		},
		getUserProfile () {
			return getUserProfile(this.perfis, this.$auth.user().perfil)
		}
	},
	computed: {
		...mapState({
			perfis: 'perfis'
		})
	}
}
</script>

<style lang="scss" scoped>
.container {
	header {
		position: absolute;
		background-color: #1B2838;
		background-image: url('../../assets/img/bgblue.png');
		width: 100%;
		-webkit-transition: height 300ms ease;
		transition: height 300ms ease;

		&.extended {
			height: 150px;
		}

		&.shorten {
			height: 150px;
		}
	}

	.content {
		margin: 0 auto 30px;
		position: relative;
		z-index:  2;
		color: #fff;
		max-width: 1360px;
		display: grid;
		grid-template-columns: 270px calc(100% - 300px);
		column-gap: 10px;
		padding: 40px 20px 0;

		.menu-open {
			display: none;

			& + input {
				display: none;
			}
		}

		aside {
			text-align: center;

			.nav-container {
				padding: 12px;
				border-radius: 20px;
				margin-top:60px;
			}
			h1 {
				a {
					img {
						width: 250px;
					}
				}
			}

			h2{
				margin-top: 20px;
				font-weight: $font-weight-default-bolder;
				color: #243244;
				border-bottom: rgb(220, 228, 241) .5px solid;
			}

			.user {
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				margin: 0 auto;
				margin-top: 30px;
				margin-bottom: 20px;

				.photo {
					width: 140px;
					height: 140px;
					border-radius: 90px;
					border: 4px solid #243244;
					background-color: #00659D!important;
					background-repeat: no-repeat;
					background-size: cover;
					margin-bottom: 10px;

					img {
						width: 100%;
						height: auto;
					}
				}

				.name {
					font-weight: $font-weight-default-bolder;
					text-transform: uppercase;
					color: #243244;
				}

				.email {
					color: #e2e41a;
					font-size: .9em;
					font-weight: 300;
				}

				.profile {
					color: #00659D;
					font-style: italic;
					font-size: 0.8em;
					font-weight: 300;
				}
			}
			nav {
				display: flex;
				justify-content: flex-start;
				flex-wrap: wrap;

				a {
					width: 100%;
				}
			}
		}

		// Gambiarra responsiva para sobrescrever o estilo cagado de antes
		@media all and (max-width: 1199px) {
			grid-template-columns: 1fr;

			.menu-open {
				position: fixed;
				bottom: 10px;
				right: 10px;
				z-index: 5;
				display: grid;
				place-items: center;
				width: 50px;
				height: 50px;
				border-radius: 50%;
				box-shadow: 1px 2px 2px 1px #FFF4;
				background-color: $main-color;
				cursor: pointer;

				.fas {
					font-size: 25px;
				}

				& + input[type=checkbox] {
					position: absolute;
					z-index: -1;
					opacity: 0;
					pointer-events: none;
				}
			}

			aside {
				position: fixed;
				z-index: -1;
				top: 0;
				left: 0;
				width: 100vw;
				height: 100vh;
				min-height: 550px;
				overflow-y: auto;
				background-color: #0006;
				opacity: 0;

				h1 {
					position: absolute;
					z-index: 2;
					top: 0;
					left: 0;
					width: 320px;
					max-width: 100%;
					background-color: $main-color;
					transform: translateX(-100%);
					transition: transform .3s .3s linear;
				}

				.nav-container {
					position: absolute;
					width: 320px;
					max-width: 100%;
					height: 100%;
					margin: 0;
					border-radius: 0;
					background-color: #FFF;
					box-shadow: 1px 2px 1px 1px #AAA3;
					transform: translateX(-100%);
					transition: transform .3s .3s linear;

					nav {
						margin-top: 80px;
						padding: 10px;

						a {
							width: 100%;
						}
					}
				}
			}

			.menu-open-chk:checked + aside {
				z-index: 1;
				opacity: 1;

				.nav-container, h1 {
					transform: translateX(0);
				}
			}
		}

		.main-content {
			margin-top: 15px;
			min-height: 100vh;

			nav {
				width: 100%;
				display: flex;
				justify-content: space-between;

				.search {
					display: flex;
					// align-items: center;
					// border-radius: 5px;
					// background-color: #ffffff;
					// color: #004e73;
					// width: 80%;
					// max-width: 550px;
					padding: 10px;

/*					input {
						border: none;
						outline: 0;
						width: 100%;
						border-radius: 5px;
						color: #1a2738;
						font-size: 1.2em;
					}

					i {
						margin: 0 12px;
						font-size: 1.2em;
					}
*/
				}

				.logged-user {
					display: flex;

					a:link {
						color: #fff;
						text-decoration: none;
						background-color: transparent;
					}

					a:visited {
						color: #fff;
						background-color: transparent;
						text-decoration: none;
					}

					a:hover {
						color: #fff;
						background-color: transparent;
						text-decoration: none;
					}

					a:active {
						color: #fff;
						background-color: transparent;
						text-decoration: none;
					}
					.user {
						display: flex;
						align-items: center;

						.thumb {
							width: 45px;
							height: 45px;
							border: 3px solid #21344d;
							border-radius: 100%;
							display: flex;
							justify-content: center;
							align-items: center;

							img {
								width: 45px;
								height: 45px;
								border-radius: 100%;
							}
						}

						span {
							display: flex;
							justify-content: center;
							align-items: center;
							background-color: #21344d;
							border-radius: 28px;
							padding: 0 20px;
							width: auto;
							height: 45px;

							&:hover {
								background-color: #1a2738;
							}
						}
					}

					button {
						background: transparent;
						border: none;
						outline: none;
						margin-left: 20px;
						color: white;
						font-weight: $font-weight-default-bolder;
						text-align: center;
						font-size: 1.1em;
						cursor: pointer;

						i {
							margin-right: 10px;
						}
					}
				}
			}
		}
	}

	footer {
		position: relative;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: #061529;
		color: #fff;
		padding-left: 30px;
		margin: 0 auto;

		.credits {
			margin: 0 auto;
			display: grid;
			grid-template-columns: min-content 1fr min-content;
			grid-gap: 0 60px;
			padding: 100px 0;
			align-items: center;
			margin-left: 40px;
			// border-bottom: 2px solid #f3f7fc;

			.help-box {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 235px;
				padding: 22px 30px;
				border-radius: 20px;
				background-color: #001736;

				i {
					font-size: 3em;
				}

				.help-text {
					font-weight: $font-weight-default-bolder;
					font-size: 1.2em;
					padding: 10px 0;
				}

				.email {
					color: #e2e41a;
				}
			}

			.logo-rodape {
				position: relative;
				top: -10px;
				width: 240px;
			}
		}

		.social-networks {
			width: 100%;
			padding: 60px 0;

			.end {
				margin: 10px auto 0;
				display: flex;
				justify-content: space-between;

				.copy {
					font-size: .9em;
					font-weight: $font-weight-default-bolder;
				}

				.socials {
					a {
						text-decoration: none;

						&:not(:last-of-type) {
							margin-right: 20px;
							font-size: 1.3em;
						}

						i {
							color: #fff;
						}
					}
				}
			}
		}

		@media all and (max-width: 900px) {
			padding: 0 20px;
			.credits {
				grid-template-columns: 1fr;
				padding: 20px;
				margin: 0;
				text-align: justify;

				.help-box, .logo-rodape {
					margin: 30px auto;
				}
			}
		}
	}
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to, .fade-move {
  opacity: 0;
}
</style>
